<template>
  <div>
    <b-card class="md-3">

      <b-row>
        <b-col class="align-left">
          <p>Configuración de los nodos</p>
        </b-col>
      </b-row>

      <!-- Tabla con la lista de dispositivos-->
      <b-card-text class="configurationTable">
        <div>
          <vue-good-table 
            :columns="columns" 
            :rows="rows"
            :isLoading.sync="isLoading">

            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'acciones'">
                  <a href="#content" style="color: #606266 !important;">
                    <span style="margin-right:10px;" @click="editRow(props.row)">
                      <i class="far fa-edit fa-lg" style="cursor:pointer"></i>
                    </span>
                  </a>
              </span>
            </template>
            <template slot="loadingContent">
              <table-loading />
            </template>
            <template slot="emptystate">
              <table-empty-state />
            </template>
          </vue-good-table>
        </div>
      </b-card-text>

    </b-card>
  </div>
</template>


<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import ConfigurationService from "@/services/ConfigurationService";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";

export default {
  name: "configuration-list",
  data(){
    return {
      alias: "",
      isLoading: false,
      columns: [
        {
          label: 'ID',
          field: 'ssid_configuration',
          hidden: true
        },
        {
          label: 'Limite superior',
          field: 'upperLimit',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Limite inferior',
          field: 'lowerLimit',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Window',
          field: 'window',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Slope',
          field: 'slope',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Threshold short',
          field: 'thresholdShort',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Saturation',
          field: 'saturation',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Max count',
          field: 'maxCount',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Threshold gathering',
          field: 'thresholdGathering',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Acciones',
          thClass: 'text-center',
          tdClass: 'text-center',
          field: 'acciones'
        },
      ],
      rows: [ ]
    };
  },
  components: {
    VueGoodTable,
    'table-loading': TableLoading, 
    'table-empty-state': TableEmptyState
  },
  methods: {
    retrieveConfiguration() {
      this.isLoading = true;
      ConfigurationService.getConfiguration()
        .then(response => {
          this.rows.push(response.data);
          this.isLoading = false;
        })
        .catch(e => {
          this.isLoading = false;
          console.log(e);
        });
    },

    refreshList() {
      this.rows = []
      this.retrieveConfiguration();
    },

    editRow(configuration){
      //Emit from child to parent configuration to be modified
      this.$emit('onClickEditConfiguration', configuration)
    }, 
  },
  mounted() {
    this.retrieveConfiguration();
  }
}
</script>